import { message, RcFile, Upload } from '@pankod/refine-antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export const getOrderNumber = (page: number, pageSize: number, index: number): number => {
    return (page - 1) * pageSize + index + 1;
};

export const numberWithCommas = (value: number | string): string => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const beforeUpload = (file: RcFile) => {
    const isImage = ['image'].includes(file.type.split('/')[0]);
    if (!isImage) {
        message.error('You can only upload Image file!');
        return Upload.LIST_IGNORE;
    }
    const isOverSize = file.size / 1920 / 480 < 5;
    if (!isOverSize) {
        message.error('Image must smaller than 5MB!');
        return Upload.LIST_IGNORE;
    }
    return false;
};

export const formatTime = (totalSeconds: number): string => {
    const dataConfig = +totalSeconds.toFixed(0);
    let seconds: any = dataConfig % 60;
    let minutes: any = Math.floor(dataConfig / 60);
    seconds = `0${seconds}`.slice(-2);
    minutes = `0${minutes}`.slice(-2);
    return `${minutes}:${seconds}`;
};

export const includesClassName = (hideCols: CheckboxValueType[], column: string) => (hideCols.includes(column) ? '' : 'hide');

export const formatNumberWith2DecimalPlaces = (value: number) => {
    return (Math.round(value * 100) / 100).toFixed(2);
};

export const formatDateTime = (value: number | string): string => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const dateTime = value ? dayjs(value).tz(userTimeZone).format('MM/DD/YYYY hh:mm A') : '';
    return dateTime;
};

export const formatDate = (date: string) => {
    return dayjs(date).format('MM/DD/YYYY');
};
